import Immutable from "immutable";

import * as Ajax from "js/common/ajax";

const path = window.path;

const baseUrl = "scheduled-report";

const requestPreview = (previewConfig) =>
  Ajax.post({
    url: path(baseUrl, "preview"),
    json: previewConfig.toJS()
  }).then(Immutable.fromJS);

const getPendingPreviewsForCurrentUser = () =>
  Ajax.get({
    url: path(baseUrl, "preview/pending")
  }).then(Immutable.fromJS);

const createScheduledReport = (reportConfig) =>
  Ajax.post({
    url: path(baseUrl),
    json: reportConfig.toJS()
  }).then(Immutable.fromJS);

const updateScheduledReport = (id, reportConfig) =>
  Ajax.put({
    url: path(baseUrl, id),
    json: reportConfig.toJS()
  }).then(Immutable.fromJS);

const getAllScheduledReports = () =>
  Ajax.get({
    url: path(baseUrl)
  }).then(Immutable.fromJS);

const getAllScheduledReportsForAdmin = () =>
    Ajax.get({
      url: path(baseUrl, "admin")
    }).then(Immutable.fromJS);

const getAllDashboardsForScheduledReportAdmin = () =>
  Ajax.get({
    url: path(baseUrl, "dashboards")
  }).then((response) =>
    Immutable.fromJS(response).map((config) => config.update("json", (str) => Immutable.fromJS(JSON.parse(str))))
  );

export {
  requestPreview,
  getPendingPreviewsForCurrentUser,
  createScheduledReport,
  updateScheduledReport,
  getAllScheduledReports,
  getAllScheduledReportsForAdmin,
  getAllDashboardsForScheduledReportAdmin
};
